import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger,
} from "@/components/ui/dialog";
import { HelpCircle, Camera, Lock, ShieldCheck } from "lucide-react";

export const HOW_STEPS = [
  "Tap Start Documentation",
  "Photograph each room — AI flags what you missed",
  "Lock it — create timestamped evidence your landlord can view",
];

const FAQS = [
  { q: "Is my report tamper-evident?", a: "Locked reports are timestamped and can't be changed without detection." },
  { q: "Can my landlord see it?", a: "Only via the link you share — no account needed." },
  { q: "What if I already moved in?", a: "Document now — dated evidence beats no evidence." },
  { q: "Is it free?", a: "Yes — one property free." },
];

export function HowItWorks() {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid="header-nav-how"
          className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-[#475569] hover:bg-[#F1F5F9] hover:text-[#0F172A] transition-colors"
        >
          <HelpCircle size={17} /> How it works
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg" data-testid="how-it-works-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-navy flex items-center gap-2">
            <ShieldCheck size={20} className="text-amber" /> How TenantSeal works
          </DialogTitle>
          <DialogDescription>Three steps to protect your security deposit — plus common questions.</DialogDescription>
        </DialogHeader>

        <ol className="mt-2 space-y-3">
          {HOW_STEPS.map((s, i) => (
            <li key={i} className="flex items-start gap-3" data-testid={`how-step-${i}`}>
              <span className="grid place-items-center h-6 w-6 rounded-full bg-amber text-navy text-xs font-bold shrink-0">{i + 1}</span>
              <span className="text-sm text-[#334155]">{s}</span>
            </li>
          ))}
        </ol>

        <div className="mt-5 border-t border-[#F1F5F9] pt-4 space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} data-testid={`how-faq-${i}`}>
              <p className="text-sm font-semibold text-navy">{f.q}</p>
              <p className="mt-0.5 text-sm text-[#475569]">{f.a}</p>
            </div>
          ))}
        </div>

        <div className="mt-2 flex items-center gap-2 text-xs text-[#94A3B8]">
          <Camera size={13} /> Guided capture <span>·</span> <Lock size={13} /> Sealed & timestamped
        </div>
      </DialogContent>
    </Dialog>
  );
}
